import {gql} from '@apollo/client';
import {useMemo} from 'react';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';

import {
  AgentFoundriesQuery as AgentFoundriesQueryData,
  AgentFoundriesQuery_agentFoundries_AgentFoundryNode as AgentFoundrySummary,
} from './__generated/AgentFoundriesQuery';

export type {AgentFoundrySummary};

export const AGENT_FOUNDRIES_QUERY = gql`
  query AgentFoundriesQuery @engComponent(name: LLM) @skipAudit {
    agentFoundries {
      id
      name
      description
      createdAt
      creatorName
    }
  }
`;

interface UseAgentFoundriesResult {
  agentFoundries: Array<AgentFoundrySummary>;
  isLoading: boolean;
  isError: boolean;
  refetch: () => Promise<unknown>;
}

export default function useAgentFoundries(): UseAgentFoundriesResult {
  const queryResult = useBenchlingQuery<AgentFoundriesQueryData>(AGENT_FOUNDRIES_QUERY, {
    fetchPolicy: 'network-only',
  });

  const agentFoundries: Array<AgentFoundrySummary> = useMemo(() => {
    if (queryResult.type !== QueryResultType.SUCCESS) {
      return [];
    }
    return queryResult.data.agentFoundries;
  }, [queryResult]);

  const isLoading = queryResult.type === QueryResultType.PENDING;
  const isError = queryResult.type === QueryResultType.ERROR;

  return {agentFoundries, isLoading, isError, refetch: queryResult.refetch};
}
